import { c as _c } from "react/compiler-runtime";
import { ChevronRight } from 'lucide-react';
import useMarkdownHeaders from '@/hooks/useMarkdownHeaders';
import { useCallback } from 'react';
import scrollTo from '@/lib/utils/scrollTo';
interface Section {
  id: string;
  number: string;
  title: string;
}
interface PrivacyIndexProps {
  markdownContent: string;
}
interface RenderSectionProps {
  section: Section;
  handleClick: (headerId: string) => void;
}
const RenderSection = t0 => {
  const $ = _c(13);
  const {
    section,
    handleClick
  } = t0;
  let t1;
  if ($[0] !== handleClick || $[1] !== section.id) {
    t1 = () => handleClick(section.id);
    $[0] = handleClick;
    $[1] = section.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== section.number) {
    t2 = <span className="font-bold text-primary text-sm min-w-[20px]">{section.number}.</span>;
    $[3] = section.number;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== section.title) {
    t3 = <span className="text-primary text-sm leading-relaxed flex-1">{section.title}</span>;
    $[5] = section.title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ChevronRight className="size-4 text-gray-400 opacity-0 group-hover:opacity-100 transition-opacity mt-0.5" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== section.id || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t5 = <button key={section.id} onClick={t1} className="flex items-start gap-3 p-3 text-left hover:bg-black rounded-lg transition-colors group w-full">{t2}{t3}{t4}</button>;
    $[8] = section.id;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
const PrivacyIndex = t0 => {
  const $ = _c(7);
  const {
    markdownContent
  } = t0;
  let t1;
  if ($[0] !== markdownContent) {
    t1 = {
      markdown: markdownContent
    };
    $[0] = markdownContent;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    columns
  } = useMarkdownHeaders(t1);
  const handleClick = _temp;
  let t2;
  if ($[2] !== columns) {
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = (currentColumn, colIndex) => <div key={colIndex} className="space-y-1">{currentColumn.map(currentHeader => <RenderSection key={currentHeader.id} handleClick={handleClick} section={currentHeader} />)}</div>;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = columns.map(t3);
    $[2] = columns;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="w-full py-12 px-6 glass"><div className="max-w-7xl mx-auto"><div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-1">{t2}</div></div></div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default PrivacyIndex;
function _temp(headerId) {
  setTimeout(() => {
    const element = document.getElementById(headerId);
    if (!element) {
      return;
    }
    const rect = element.getBoundingClientRect();
    const targetY = Math.max(0, rect.top + window.scrollY - 120);
    scrollTo({
      targetY,
      duration: 3000
    });
  }, 100);
}